<template>
  <div class="common-box CustomerManagement">
    <div>
      <el-form
        inline
        ref="form"
        class="search-form common-box-search-form"
        label-position="right"
        :model="form"
        label-width="70px"
      >
        <search-form @search="handleSearch" @refresh="handleRefresh">
          <div slot="content">
            <el-form-item label="客户名称：">
              <el-input
                size="mini"
                v-model.trim="form.customerName"
                placeholder="请输入客户名称"
                clearable
                @change="handleSearchListData"
              ></el-input>
            </el-form-item>
           <el-form-item label="项目：">
             <el-select
               size="mini"
               v-model="form.projectId"
               filterable
               placeholder="请选择项目"
               clearable
               reserve-keyword
               :remote="true"
               :remote-method="searchProjectList"
               @visible-change="searchProjectList('')"
               @change="handleSearchListData"
             >
               <el-option
                 v-for="item in projectList"
                 :key="item.id"
                 :label="item.projectName"
                 :value="item.id"
               ></el-option>
             </el-select>
           </el-form-item>
           <el-form-item label="电梯：" prop="liftIdList" class="mr0">
             <el-select
               size="mini"
               v-model="form.liftIdList"
               filterable
               placeholder="请选择电梯"
               clearable
               reserve-keyword
               :multiple="true"
               collapse-tags
               :remote="true"
               :remote-method="searchLiftList"
               @visible-change="searchLiftList('')"
               @change="handleSearchListData"
             >
               <el-option
                 v-for="item in liftList"
                 :key="item.liftId"
                 :label="item.liftLocation"
                 :value="item.liftId"
               ></el-option>
             </el-select>
           </el-form-item>
          </div>
        </search-form>
      </el-form>
    </div>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
        <el-button
          size="mini"
          type="primary"
          v-if="hasRole['KHGZSH']"
          @click="deleteContractMore"
          class="plr28"
          plain
          >删除</el-button
        >
      </div>
      <div class="table__container">
        <el-table
          v-loading="tableLoading"
          :data="list"
          height="100%"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="liftLocation"
            label="电梯位置"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="projectName"
            label="项目名称"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="projectName"
            label="项目名称"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="propertyUnitName"
            label="使用单位名称"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="customerName"
            label="客户名称"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="customerPhone"
            label="联系方式"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="nickname"
            label="微信昵称"
            width="150"
          ></el-table-column>

          <el-table-column label=" " prop=" "></el-table-column>
          <el-table-column label="操作" width="202px" fixed="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                v-if="hasRole['KHGZSH']"
                type="text"
                @click="deleteContract(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getPageList,
  deletePermissionLift
} from "@/api/CustomerFollowManagement";
import { getProjectSimpleList } from "@/api/MaintenanceWorkOrder";
import { getLiftSimpleList } from "@/api/MaintenancePlan";
export default {
  name: "CustomerFollowManagement",
  components: {
  },
  data() {
    return {
      form: {
        customerName: null,
      },
      tableLoading: false,
      list: [],
      multipleSelection: [],
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      showAddUser: false,
      userDetail: null,
      showCode: false,
      url: "",
      liftList: [],
      projectList: []
    };
  },
  computed: {
    hasRole: function () {
      return this.$store.getters["common/promise/getRole"](this.$route.path);
    },
  },
  created() {
    this.getListData();
  },
  methods: {
    async searchProjectList(keyword) {
      const res = await getProjectSimpleList({
        keyword: keyword,
        size: 1000,
      });
      if (res.code === 200) {
        this.projectList = res.data;
      }
    },
    async searchLiftList(keyword) {
      if (!this.form.projectId) {
        return;
      }
      const res = await getLiftSimpleList({
        keyword: keyword,
        size: 100,
        projectId: this.form.projectId,
      });
      if (res.code === 200) {
        this.liftList = res.data;
      }
    },
    getParams() {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      return params;
    },
    async getListData() {
      const params = await this.getParams();
      const res = await getPageList(params);
      if (res.code === 200) {
        this.list = res.data.list;
        this.total = res.data.total;
      }
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleRefresh() {
      for (let key in this.form) {
        if (Array.isArray(this.form[key])) {
          this.form[key] = [];
        } else {
          this.form[key] = "";
        }
      }
      this.pageIndex = 1;
      this.getListData();
    },
    handleSearchListData() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleEdit(row) {
      this.userDetail = row;
      this.showAddUser = true;
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getListData();
    },
    deleteContractMore(row) {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择要删除的行");
        return;
      }
      let idList = this.multipleSelection.map((item) => item.id);
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deletePermissionLift({ idList });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteContract(row) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deletePermissionLift({ idList: [row.id] });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss">
.CustomerManagement {
  .el-radio-group {
    margin-bottom: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/CustomerFollowManagement/CustomerFollowManagement.vue